export default __webpack_public_path__ + "static/media/Calendar_of_Event_Postal.694bfd6d.pdf";